import Indicator, { IndicatorType } from '../../types/Indicator'

const ThickBlue: Indicator = {
  type: IndicatorType.OSCILLATOR,
  value: 'thickBlue',
  label: 'Thick Blue',
  fields: ['thickBlue'],
  excludeSelfInRHS: true,
}

export default ThickBlue
